module.exports = __webpack_public_path__ + "media/wyposazenie/zabezpieczenia-white@2x-abddc73c.png";